import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ReporteEstadisticasHallazgosService = async (values) => {
    try {
        const resultado = await instance.Backend.post("/Informe/ReporteEstadisticasHallazgosPorAreaNegocio",
            values, customConfig
        );
        return resultado
    } catch (error) {
        console.log(error);
    }
}
export { ReporteEstadisticasHallazgosService };